import React from "react";
import { cn } from "tailwind-variants";
import UseSvg from "common/vue/components/UseSvg.react.vue";
import "./TabButton.scss";

export default function TabButton({ active, icon, onClick, children, ...restProps }) {
  return (
    <button
      {...restProps}
      className={cn(
        "tab-button scope-6eba7857",
        { "tab-button--active": active },
        restProps.className
      )}
      type="button"
      onClick={e => {
        e.preventDefault();
        e.stopPropagation();
        onClick(e);
      }}
      data-testid="tab-button"
    >
      {icon ? (
        <UseSvg
          className="tab-button__icon scope-6eba7857"
          icon={icon}
          data-testid="tab-button-icon"
        />
      ) : null}
      {children}
    </button>
  );
}
